import { combineReducers } from "redux";
import { reducer as closedCaptionReducer } from "./closedCaptionSlice.js";

export const reducer = combineReducers({
  closedCaption: closedCaptionReducer,
});
